import { get, patch, post } from '@/helpers/httpHandler';
import { cloneDeep } from 'lodash';

export default {
  getItemsList({ commit }, { params } = {}) {
    return get(`booking/reservations`, {
      ...params.filters,
      ...params.paginationOptions
    }).then(response => {
      commit('setFilters', cloneDeep(params.filters));
      commit('setPaginationOptions', cloneDeep(params.paginationOptions));

      return response;
    });
  },

  getBookingReservationsStatuses({ commit }) {
    return get(`booking/filters/statuses/reservations`).then(response => {
      commit('setBookingReservationsStatuses', response.data.data);

      return response;
    });
  },

  getFilteredBuildingComplexes(_, params) {
    return get(`/booking/filters/building-complexes`, params);
  },

  getFilteredBuildings(_, params) {
    return get(`/booking/filters/buildings`, params);
  },

  getFilteredResources(_, params) {
    return get(`/booking/filters/titles`, params);
  },

  getFilteredCustomers(_, params) {
    return get(`/booking/filters/persons`, params);
  },

  getBookingReservation: (_, { reservationId }) => {
    return get(`/booking/reservation/${reservationId}`);
  },

  storeBookingReservation: (_, { reservation }) => {
    return post(`/booking/reservation`, reservation);
  },

  updateBookingReservation: (_, { reservationId, reservation }) => {
    return patch(`/booking/reservation/${reservationId}`, reservation);
  }
};
